import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import { isHostComponent } from "./isHostComponent.es.js";
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === void 0 || isHostComponent(elementType)) {
    return otherProps;
  }
  return _extends({}, otherProps, {
    ownerState: _extends({}, otherProps.ownerState, ownerState)
  });
}
export {
  appendOwnerState
};
//# sourceMappingURL=appendOwnerState.es.js.map
